import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SoaksRepository } from './dto/soak-style.repo';
import { SoaksAdapter } from './dto/soaks.adapter';
import { SoaksController } from './soaks.controller';
import { SoakService } from './soaks.service';
import { SoakStyleEntity } from './soaks.entity';


@Module({
  imports:[
    TypeOrmModule.forFeature([SoakStyleEntity,SoaksRepository])],
  controllers: [SoaksController],
  providers: [ApplicationExceptionHandler,SoaksAdapter,SoakService]
})
export class SoakModule {}
